import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import useNavigation from '../../utils/Navigation';
import './Header.css';
import logo from './../../images/MG-Study-Logo.jpg';
import flag from './../../images/Flag.jpg';
import close from './../../images/close.png';

const Header = () => {
  const [activeSection, setActiveSection] = useState('');
  const navigateToSection = useNavigation();
  const currentLocation = useLocation();

  useEffect(() => {
    const hash = currentLocation.hash;
    if (hash) {
      setActiveSection(hash.slice(1));
    } else {
      const pathSegments = currentLocation.pathname.split('/');
      const lastPathSegment = pathSegments[pathSegments.length - 1];
      setActiveSection(lastPathSegment || 'home');
    }
  }, [currentLocation.pathname, currentLocation.hash]);



  const handleLinkClick = () => {
    const navbarCollapse = document.getElementById('collapsibleNavbar');
    if (navbarCollapse.classList.contains('show')) {
      navbarCollapse.classList.remove('show');
    }
  };

  return (
    <section className="header" id="home">
      <nav className="navbar navbar-expand-sm fixed-top">
        <div className="container">
          <div className="col-12 col-sm-2">
            <Link className="navbar-brand" to="/" alt="logo" onClick={() => {
              navigateToSection('home');
              handleLinkClick();
            }} >
              <img src={logo} alt="logo " />
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapsibleNavbar">
              <span className="navbar-toggler-icon"></span>
            </button>
          </div>

          <div className="col-12 col-sm-10">
            <div className="collapse navbar-collapse" id="collapsibleNavbar">
              <div className="close_nav"><button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapsibleNavbar"><img src={close} alt="Close" /> </button></div>
              <ul className="navbar-nav">
                <li className={`nav-item ${activeSection === 'home' ? 'active' : ''}`}>
                  <Link to="/" className="nav-link home" onClick={() => {
                    navigateToSection('home');
                    handleLinkClick();
                  }} >
                    {/* {localization.headername}   */}
                    Home
                  </Link >
                </li>
                <li className={`nav-item ${activeSection === 'aboutStudy' ? 'active' : ''}`}>
                  <Link to="/#aboutStudy" className="nav-link aboutStudy" onClick={() => {
                    navigateToSection('aboutStudy');
                    handleLinkClick();
                  }} > About the Trial  </Link >
                </li>
                <li className={`nav-item ${activeSection === 'eligibility' ? 'active' : ''}`}>
                  <Link to="/#eligibility" className="nav-link eligibility" onClick={() => {
                    navigateToSection('eligibility');
                    handleLinkClick();
                  }} > Eligibility  </Link >
                </li>
                <li className={`nav-item ${activeSection === 'faqs' ? 'active' : ''}`}>
                  <Link className="nav-link" to="/faqs" alt="faqs">FAQs</Link>
                </li>
                {/* <li className={`nav-item ${activeSection === 'location' ? 'active' : ''}`}>
                  <Link className="nav-link" to="/location" alt="location">Locations</Link>
                </li> */}

                <li className={`nav-item ${activeSection === 'location' ? 'active' : ''}`}>
  <div className="illustrative-container">
    <p className="illustrative-text">***This is for illustrative purposes only***</p>
  </div>
</li>
                <li className="nav-item dropdown">
                  <Link className="nav-link dropdown-toggle" to="" role="button" data-bs-toggle="dropdown">
                    <img src={flag} alt="flag " />
                    English
                    {/* {selectedLanguage === 'en' ? 'English' : 'Kannada'} */}
                  </Link>
                  <ul className="dropdown-menu">
                    <li>
                      <Link className="dropdown-item" to=""
                        // onClick={() => changeLanguage('en')} 
                        onClick={() => handleLinkClick()}
                        alt="english">English</Link>
                    </li>
                    {/* <li>
                                <a className="dropdown-item" href="#" onClick={() => changeLanguage('ka')} alt="kannada">Kannada</a>
                            </li> */}
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </section>
  );
};

export default Header;





